import React, {useEffect, useState} from 'react';

const Partner = ({
                     documentUploadUrlPublic,
                     documentUrlDataPublic,
                     getCityStateByPincode,
                     pincodeData = [],
                     lat = '',
                     long = '',
                     dropdownValue,
                     handleInput,
                     accountDetailsByIdData,
                     isEdit = false,
                     inputList,
                     isView = false
                 }) => {

    const [leadSource, setLeadSource] = useState('');

    useEffect(() => {
        handleInput(leadSource, 'lead_source_id')
    }, [leadSource])

    useEffect(() => {
        if (accountDetailsByIdData !== [] && accountDetailsByIdData?.account_type_id !== undefined) {
            handleInput(accountDetailsByIdData?.client_name, 'client_name')
            handleInput(accountDetailsByIdData?.lead_source_id, 'lead_source_id')
            handleInput(accountDetailsByIdData?.first_contact_date, 'first_contact_date')
        }

    }, [accountDetailsByIdData])

    return (
        <>
            <div className="col-md-12">
                <div
                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                    <h1 className="h3 mb-0 text-black-100">Account Details</h1>
                </div>
                <div className="card-body bg-white">
                    <div className="user">
                        <div className="form-group row">
                            <div className="col-sm-6 float-field mt-1">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(e.target.value, 'client_name')
                                       }}
                                       required
                                       value={inputList[0]?.client_name}
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Business Name <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            {/*<div className="col-sm-6 float-field mt-1">*/}
                            {/*    <select className="form-control form-control-user" onChange={(e) => {*/}
                            {/*        setSiteTypeId(e.target.value)*/}
                            {/*    }}>*/}
                            {/*        <option value="">Select Site Type</option>*/}
                            {/*        {dropdownValue?.supply_site_type.map((val) => {*/}
                            {/*            return (*/}
                            {/*                <option value={val?.id}>{val.name}</option>*/}
                            {/*            )*/}
                            {/*        })}*/}
                            {/*        required*/}
                            {/*    </select>*/}
                            {/*    <label className="large-label float-lb">*/}
                            {/*        Site Type <i className="bi bi-asterisk astrick-icon"></i>*/}
                            {/*    </label>*/}
                            {/*</div>*/}
                            {/*<div className="col-sm-6 float-field mtk-1">*/}
                            {/*    <input type="text"*/}
                            {/*           className="form-control form-control-user"*/}
                            {/*           placeholder=" "*/}
                            {/*           onChange={(e) => {*/}
                            {/*               handleInput(e.target.value, 'building_name')*/}
                            {/*           }}*/}
                            {/*           required*/}
                            {/*    />*/}
                            {/*    <label className="large-label float-lb">*/}
                            {/*        Site/Account Name <i className="bi bi-asterisk astrick-icon"></i>*/}
                            {/*    </label>*/}
                            {/*</div>*/}
                            {/*<div className="col-sm-6 float-field mt-1">*/}
                            {/*    <input type="text"*/}
                            {/*           className="form-control form-control-user"*/}
                            {/*           placeholder=" "*/}
                            {/*           onChange={(e) => {*/}
                            {/*               handleInput(e.target.value, 'lead_type')*/}
                            {/*           }}*/}
                            {/*    />*/}
                            {/*    <label className="large-label float-lb">*/}
                            {/*        Lead Type*/}
                            {/*    </label>*/}
                            {/*</div>*/}
                            <div className="col-sm-6 float-field mtk-05 d-mtk-03">
                                <select className="form-control form-control-user" onChange={(e) => {
                                    setLeadSource(e.target.value)
                                }} required disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                    <option value="">Select Lead Source</option>
                                    {dropdownValue?.supply_lead_source!== undefined && dropdownValue?.supply_lead_source.map((val) => {
                                        return (
                                            <>
                                                {(accountDetailsByIdData?.lead_source_id === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </>    :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                </select>
                                <label className="large-label float-lb">
                                    Lead Source <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            {(parseInt(accountDetailsByIdData?.lead_source_id) === 24 || parseInt(leadSource) ===24) &&
                                <div className="col-md-6 float-field mt-sel">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        handleInput(e.target.value, 'sale_team_name')
                                    }} required >
                                        <option value="">Source of acquisition</option>
                                        {accountDetailsByIdData?.sale_team_name === "Indiamart" ?
                                            <>
                                                <option value="Indiamart" selected>Indiamart</option>
                                                <option value="Just Dial">Just Dial</option>
                                                <option value=" Park+ online leads "> Park+ online leads</option>
                                                <option value="Referral">Referral</option>
                                            </>
                                            : accountDetailsByIdData?.sale_team_name === "Just Dial" ?
                                                <>
                                                    <option value="Indiamart">Indiamart</option>
                                                    <option value="Just Dial" selected>Just Dial</option>
                                                    <option value=" Park+ online leads "> Park+ online leads</option>
                                                    <option value="Referral">Referral</option>
                                                </> :
                                                accountDetailsByIdData?.sale_team_name === "Park+ online leads" ?
                                                    <>
                                                        <option value="Indiamart">Indiamart</option>
                                                        <option value="Just Dial">Just Dial</option>
                                                        <option value="Park+ online leads" selected> Park+ online leads
                                                        </option>
                                                        <option value="Referral">Referral</option>
                                                    </> :
                                                    accountDetailsByIdData?.sale_team_name === "Referral" ?
                                                        <>
                                                            <option value="Indiamart">Indiamart</option>
                                                            <option value="Just Dial">Just Dial</option>
                                                            <option value="Park+ online leads"> Park+ online
                                                                leads
                                                            </option>
                                                            <option value="Referral" selected>Referral</option>
                                                        </>
                                                        :
                                                        <>
                                                            <option value="Indiamart">Indiamart</option>
                                                            <option value="Just Dial">Just Dial</option>
                                                            <option value="Park+ online leads"> Park+ online leads</option>
                                                            <option value="Referral">Referral</option>
                                                        </>
                                        }

                                    </select>
                                    <label className="large-label float-lb">
                                        Source of acquisition <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }
                            <div className="col-sm-6 float-field mtk-05 d-mtk-03">
                                <input type="date"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(e.target.value, 'first_contact_date')
                                       }}
                                       required
                                       value={inputList[0]?.first_contact_date}
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    First Contact Date <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Partner;